import React, { useEffect, useState, useCallback } from "react";
import { ReactComponent as BackIcon } from "../../assets/svgs/back-square.svg";
import TextStyles from "../../components/Elements/TextStyles/TextStyles";
import { useLocation, useNavigate } from "react-router-dom";
import { getApi } from "../../api/api_instance";
import { API_URLS } from "../../api/apiUrls";
// import toast from "react-hot-toast";
import { SearchBar } from "../../components/Elements/Search/SearchBar";
import { QuestionForm } from "./components/questionForm";
import { QuestionFormScope } from "./components/questionFormScope";
import { QuestionFormScope1234 } from "./components/questionFormScope1234";
import QuestionAnswerView from "./components/QuestionAnswerView";

const Questions = () => {
  const [questionsData, setQuestionsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalDivisionQuestion, setTotalDivisionQuestion] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();
  const [isScope123Open, setScope123Open] = useState(false);
  const [isViewMode, setIsViewMode] = useState(false);
  const { section, subSectionId, subSectionName, totalQuestions } =
    location.state || {};

  const [searchTerm, setSearchTerm] = useState("");

  const fetchQuestions = useCallback(async () => {
    if (!subSectionId) return;
    try {
      console.log("state is", isScope123Open);
      setLoading(true);
      const response = await getApi({
        apiUrl: API_URLS.QUESTIONS_BY_SUBSECTION(subSectionId, searchTerm),
      });

      if (response.success) {
        console.log("Questions (raw response):", response.data.divisions);
        setQuestionsData(response.data.divisions);
        setTotalDivisionQuestion(response?.totalDivisionQuestion ?? 0);
        console.log(response?.totalDivisionQuestion, "resosnejustnoww");
      } else {
        setQuestionsData([]);
      }
    } catch (error) {
      console.error("Error fetching questions:", error);
      // toast.error("Failed to fetch questions");
    } finally {
      setLoading(false);
    }
  }, [subSectionId, searchTerm]);

  useEffect(() => {
    if (!section) {
      console.warn("No section data passed via location.state");
    } else {
      console.log("Section is :", section);
      console.log("subsection is:", subSectionId);
    }
    if (
      section === "governance" ||
      section === "organization_detail" ||
      section === "scope1_2" ||
      section === "scope_3" ||
      section === "employee_detail" ||
      section === "vendor_detail" ||
      section === "sdg_1" ||
      section === "sdg_2" ||
      section === "sdg_3" ||
      section === "sdg_4" ||
      section === "sdg_5" ||
      section === "sdg_6" ||
      section === "sdg_7" ||
      section === "sdg_8" ||
      section === "sdg_9" ||
      section === "sdg_10" ||
      section === "sdg_11" ||
      section === "sdg_12" ||
      section === "sdg_13" ||
      section === "sdg_14" ||
      section === "sdg_15" ||
      section === "sdg_16" ||
      section === "sdg_basic_detail" ||
      section === "sdg_17"||
      section === "finance"||
      section === "environment_section"
    ) {
      setScope123Open(true);
    }
    fetchQuestions();
  }, [fetchQuestions, section]);

  return (
    <div
      style={{ backgroundColor: "#fff" }}
      className="min-h-screen px-[20px] pb-20"
    >
      <div className="flex justify-end text-xs font-light p-3">
        <p>Home</p>
        <span>/</span>
        <p>My Question Bank</p>
        <span>/</span>
        <TextStyles color="gradient">Questions</TextStyles>
      </div>

      <div className="flex items-center gap-2 text-xl font-bold mb-5">
        <BackIcon onClick={() => navigate(-1)} className="cursor-pointer" />
        <TextStyles color="gradient">
          Questions - {subSectionName || "Sub-Section"}
        </TextStyles>
      </div>
      <div
        style={{
          border: "1px solid #3BA2B959",
          borderRadius: "10px",
          paddingTop: "20px",
          paddingBottom: "20px",
          boxShadow: "0px 0px 16px 0px #3BA2B91F",
          backgroundColor: "#fff",
        }}
      >
        <div className="flex justify-between items-center px-8 border-b border-gray-100 pb-5">
          <div className="flex gap-4">
            <p className="px-8 h-[42px] flex items-center justify-center border border-[#06513D] bg-[#B6D4D933] rounded-md text-[#06513D] text-sm font-medium">
              TOTAL QUESTIONS: {totalDivisionQuestion}
            </p>

            {/* <SearchBar
              width="300px"
              onSearch={(value) => setSearchTerm(value)}
            /> */}
          </div>

          <div className="flex items-center gap-2">
            <button
              onClick={() => setIsViewMode(!isViewMode)}
              className={`px-6 py-2 rounded-lg font-bold text-sm transition-all duration-300 transform active:scale-95 ${
                isViewMode
                  ? "bg-teal-600 text-white shadow-lg shadow-teal-200"
                  : "border-2 border-teal-600 text-teal-600 hover:bg-teal-50"
              }`}
            >
              {isViewMode ? "✏️ Edit Questions" : "📊 View Summary"}
            </button>
          </div>
        </div>

        <div className="px-8 mt-6">
          {loading ? (
            <div className="flex flex-col items-center justify-center py-40">
              <div className="w-12 h-12 border-4 border-teal-100 border-t-teal-600 rounded-full animate-spin"></div>
              <p className="mt-4 text-gray-400 font-bold uppercase tracking-widest text-xs">
                Loading...
              </p>
            </div>
          ) : questionsData.length > 0 ? (
            isViewMode ? (
              <QuestionAnswerView
                questions={questionsData}
                sectionId={section}
                subSectionId={subSectionId}
              />
            ) : isScope123Open ? (
              <QuestionFormScope1234
                questions={questionsData}
                sectionId={section}
                subSectionId={subSectionId}
              />
            ) : (
              <div className="py-6">
                <QuestionForm questions={questionsData} />
              </div>
            )
          ) : (
            <div className="py-20 text-center border-2 border-dashed border-gray-100 rounded-2xl mx-12">
              <p className="text-gray-400 font-medium italic">
                No questions found in this sub-section.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Questions;
